import { render, staticRenderFns } from "./HighlightedNewsCardList.vue?vue&type=template&id=94e3d4d2&scoped=true&"
import script from "./HighlightedNewsCardList.vue?vue&type=script&lang=js&"
export * from "./HighlightedNewsCardList.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedNewsCardList.vue?vue&type=style&index=0&id=94e3d4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e3d4d2",
  null
  
)

export default component.exports